// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"3e939b4e","590":"7babb562","676":"2b36fb74","728":"26d52cc2","750":"e8b7347e"}[chunkId] + ".chunk.css";
};